import PlacesPage from "./PlacesPage";

export default PlacesPage;
